import React from 'react';
import { StyleSheet } from 'aphrodite/no-important';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { useTheme } from '../../../theming/useTheme';
import { BaseUnit } from '../../../theming/baseUnitDefinition';
import { MEDIA_BREAKPOINTS } from '../../../mediaQueries.const';

interface TaboolaComponentThemeProps {
  baseUnit: BaseUnit;
}

const createStyle = (baseUnit: BaseUnit) => {
  return StyleSheet.create({
    style: {
      paddingTop: `${baseUnit * 2}px`,
      paddingLeft: `${baseUnit}px`,
      paddingRight: `${baseUnit}px`,
      [MEDIA_BREAKPOINTS.large]: {
        paddingLeft: `${baseUnit + 80}px`,
      },
    },
  });
};

export const Taboola: React.FunctionComponent = React.memo(() => {
  const { baseUnit } = useTheme<TaboolaComponentThemeProps>();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const style = createStyle(baseUnit);
  return (
    <ErrorBoundary>
      <div />
    </ErrorBoundary>
  );
});
